export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_API = process.env.REACT_APP_BASE_API;
export const AZURE_API_MANAGEMENT_URL = process.env.REACT_APP_AZURE_API_MANAGEMENT_URL;
export const AZURE_API_MANAGEMENT_SUBSCRIPTION_KEY =
  process.env.REACT_APP_AZURE_API_MANAGEMENT_SUBSCRIPTION_KEY;
export const SEARCH_DESTINATIONS_KEY = 'P0Qail2mKDdyWq2x7lAglGOSFBD19GBAhfhPGcyL47AzSeD3bAO6';
export const SEARCH_POSTS_KEY = 'ef05c85bb8b9820eda63c21dc16bcd8c658bab4bee3f48eceabe5ae620a7996b';
export const MAP_KEY = process.env.REACT_APP_MAP_KEY;
export const SANITY_API = process.env.SANITY_API;
